// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"827":"29c55628","903":"d078abfc"}[chunkId] + ".chunk.css";
};